import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { Store } from '@ngrx/store';
import swal from 'sweetalert2';
import { AddEditPromoReferenceComponent } from './addEditPromoReference.component';

import * as fromRootStore from '../../../reducers';
import { PromoReferenceService, PromoTypeService } from '../../../services/index';

@Component({
    selector: 'promo-reference-tab',
    templateUrl: './promoReference.component.html',
})
export class PromoReferenceMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext: any;

    public mode: string;
    public user_type: string;
    public list: any[] = [];
    public promoReferenceData: any[] = [];

    isLoadMask: Promise<any>;
    isLoading: boolean = false;
    loadingIndicator: boolean = true;
    reorderable: boolean = true;
    userType: string;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'promo_reference',
        orderDir: 'asc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel: any;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;
    filterData = {
        "search_data": ""
    };
    filterExpand: boolean = false;

    constructor(
        public store: Store<fromRootStore.State>,
        private promoReferenceService: PromoReferenceService,
        private promoTypeService: PromoTypeService,
        private modalService: BsModalService,
        public toasterService: ToasterService
    ) { }

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Promo Type', prop: 'promo_type', width: 180, minWidth: 180, maxWidth: 180 },
            { name: 'Promo Reference', prop: 'promo_reference', width: 200, minWidth: 200, maxWidth: 200 },
            { name: 'Promo Reference Details', prop: 'promo_reference_details', width: 250, minWidth: 250, maxWidth: 300 },
            { name: 'Status', prop: 'status', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Action', prop: 'sno', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });
    }

    /**
     * Called whenever the user changes page
     */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getPromoReferenceList();
        }
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100);
    }

    onOpenedFilter(): void {
        setTimeout(function() {
            $('#filterSearch').focus();
        }, 100);
    }

    getPromoReferenceList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            filter: JSON.stringify(this.filterData)
        };

        let that = this;
        this.isLoadMask = this.promoReferenceService
            .getPromoReferenceList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.promoReferenceData = res.data;
                that.userType = res.userType;
            });
    }

    onChangePageSize(limit: any) {
        this.page.limit = limit;
        this.getPromoReferenceList();
    }

    bsModalRef: BsModalRef;
    public onAddEditPromoReference(mode: string, row: any, userType: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditPromoReferenceComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = mode + ' Promo Reference';
        this.bsModalRef.content.userType = userType;
        this.bsModalRef.content.promoReferenceData = Object.assign({}, row);
        this.bsModalRef.content.promoReferenceLoadEvent.subscribe(($e: any) => {
            that.getPromoReferenceList();
        });
    }


    clearFilter(): void {
        this.filterData = { "search_data": "" };
        this.applyFilter();
    }

    applyFilter(): void {
        this.filterPanel.close();
        this.getPromoReferenceList();
    }
}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/promoReference/promoReference.component.ts